import { Mail, MessageCircle, MonitorSmartphone, Phone } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/api/endpoints';
import { Card, ViewHeader } from '../components/ui';

/**
 * Контакты — реальные данные из settings/contacts (email, phone, tg, vk).
 * Иконки/заголовки — как в дизайне, значения подставляются из бэка.
 */
export function ContactsView() {
  const { data } = useQuery({
    queryKey: ['contacts-settings'],
    queryFn: settingsApi.getContacts,
    staleTime: 5 * 60_000,
  });

  const methods = data
    ? [
        {
          title: 'Telegram',
          value: data.telegram || '—',
          caption: data.telegramNote || 'Быстрый канал для статусов и уточнений',
          icon: MessageCircle,
          href: data.telegram ? `https://t.me/${data.telegram.replace(/^@/, '')}` : undefined,
        },
        {
          title: 'Телефон',
          value: data.phone || '—',
          caption: data.phoneNote || 'Критичные инциденты 24/7',
          icon: Phone,
          href: data.phone ? `tel:${data.phone.replace(/[^+\d]/g, '')}` : undefined,
        },
        {
          title: 'Email',
          value: data.email || '—',
          caption: data.emailNote || 'Документы, отчёты и длинные описания',
          icon: Mail,
          href: data.email ? `mailto:${data.email}` : undefined,
        },
        {
          title: 'ВКонтакте',
          value: data.vk || '—',
          caption: data.vkNote || 'Соцсеть поддержки',
          icon: MonitorSmartphone,
          href: data.vkUrl || undefined,
        },
      ]
    : [];

  return (
    <div className="view active">
      <ViewHeader title="Контакты" text="Свяжитесь с поддержкой удобным способом — мы на связи 24/7." />
      <div className="tile-grid">
        {methods.length === 0 ? (
          <Card className="topic-card">
            <span className="mini-icon">
              <Phone size={21} />
            </span>
            <h4>Загрузка…</h4>
            <p>Контакты подгружаются с сервера.</p>
          </Card>
        ) : (
          methods.map((method) => {
            const Icon = method.icon;
            const inner = (
              <>
                <span className="mini-icon">
                  <Icon size={21} />
                </span>
                <h4>{method.title}</h4>
                <strong>{method.value}</strong>
                <p>{method.caption}</p>
              </>
            );
            return method.href ? (
              <a className="topic-card card" key={method.title} href={method.href} target="_blank" rel="noreferrer">
                {inner}
              </a>
            ) : (
              <Card className="topic-card" key={method.title}>
                {inner}
              </Card>
            );
          })
        )}
      </div>
      {data?.hours ? (
        <div style={{ marginTop: 20, color: 'var(--muted)', fontSize: 13 }}>
          График работы: <strong style={{ color: 'var(--text)' }}>{data.hours}</strong>
          {data.hoursNote ? ` — ${data.hoursNote}` : ''}
        </div>
      ) : null}
    </div>
  );
}
